/**
 * Autogenerated file.
 * For adding or changing icons, see README.MD
 */
import React from 'react';
import { createIcon } from '../../icon/create-icon'; // Outline

const InfoOutline = props => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  stroke: "var(--i-color)",
  strokeLinecap: props.strokeLinecap,
  strokeLinejoin: props.strokeLinejoin,
  strokeWidth: "var(--i-s-width)",
  d: "M11.25 11.25H12v5.25h.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  d: "M11.812 8.81c.518 0 .938-.42.938-.93a.938.938 0 1 0-1.875 0c0 .51.42.93.937.93z"
})); // Fill


const InfoFill = props => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  d: "M12 2.25a9.76 9.76 0 0 0-5.417 1.64A9.765 9.765 0 0 0 2.437 13.9a9.738 9.738 0 0 0 2.67 4.99 9.66 9.66 0 0 0 4.991 2.67c1.891.38 3.852.19 5.633-.55a9.785 9.785 0 0 0 4.376-3.59A9.775 9.775 0 0 0 21.75 12a9.785 9.785 0 0 0-2.86-6.89A9.738 9.738 0 0 0 12 2.25zm-.187 4.5c.222 0 .44.07.625.19s.33.3.414.5a1.14 1.14 0 0 1-.244 1.23c-.157.16-.358.26-.576.31-.218.04-.444.02-.65-.07a1.055 1.055 0 0 1-.505-.41 1.13 1.13 0 0 1 .14-1.42c.211-.21.497-.33.796-.33zm.937 10.5H12a.751.751 0 0 1-.75-.75V12a.751.751 0 0 1 0-1.5H12a.751.751 0 0 1 .75.75v4.5a.751.751 0 0 1 0 1.5z"
})); // DuoTone


const InfoDuotone = props => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  d: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  stroke: "var(--i-color)",
  strokeLinecap: props.strokeLinecap,
  strokeLinejoin: props.strokeLinejoin,
  strokeWidth: "var(--i-s-width)",
  d: "M11.25 11.25H12v5.25h.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  d: "M11.812 9a1.124 1.124 0 1 0-1.124-1.12c0 .62.503 1.12 1.124 1.12z"
}));
/**
  Icon InfoIcon in security group
*/


export const InfoIcon = createIcon('InfoIcon', 'info', 'security', InfoOutline, InfoFill, InfoDuotone, "0 0 24 24");